import { Component, Input, SimpleChanges } from '@angular/core';
import { Invoice } from '../models/invoice.model';
import * as xml2js from 'xml2js';

@Component({
  selector: 'app-receipt-invoice',
  template: `
    <h5>Factura</h5>
    <table class="table table-sm" style="font-size: 0.8em;">
      <tbody class="text-dark">
        <tr class="border-bottom-secondary">
          <th colspan="3" scope="col">Folio fiscal</th>
          <td colspan="5" scope="col" class="text-end">{{invoice?.uuid}}</td>
        </tr>
        <tr class="border-bottom-secondary">
          <th colspan="3">Fecha emisión</th>
          <td colspan="5" class="text-end">{{invoice?.fecha | date: 'dd/MM/yyyy HH:mm'}}</td>
        </tr>
        <tr class="border-bottom-secondary">
          <td colspan="3" scope="col">Subtotal</td>
          <td colspan="5" scope="col" class="text-end">{{invoiceData?.base | currency: 'USD'}}</td>
        </tr>
        <tr class="border-bottom-secondary">
          <td colspan="3" scope="col">IVA</td>
          <td colspan="5" scope="col" class="text-end">{{invoiceData?.taxes | currency: 'USD'}}</td>
        </tr>
        <tr class="border-bottom-secondary">
          <td colspan="3" scope="col">Total</td>
          <td colspan="5" scope="col" class="text-end">{{invoiceData?.total | currency: 'USD'}}</td>
        </tr>
      </tbody>
    </table>
  `,
  styles: ``
})
export class ReceiptInvoiceComponent {
  @Input() invoice: Invoice | null = null;

  parser: any;
  invoiceData: any = {
    base: 0,
    taxes: 0,
    total: 0
  };

  ngOnChanges(changes: SimpleChanges) {
    if (changes['invoice'] && changes['invoice'].currentValue) {      
      this.processInvoice(this.invoice);
    }
  }

  async processXML(xml: any) {
    this.parser = new xml2js.Parser({ trim: true, explicitArray: true });
    return await this.parser.parseStringPromise(xml).then(function (result: any) {
      return result;
    });
  }

  async processInvoice(invoice: Invoice | null) {
    const comprobante: any = await this.processXML(invoice!.cfdixml);
    const impuestos: any = comprobante['cfdi:Comprobante']['cfdi:Impuestos'][0]['cfdi:Traslados'][0]['cfdi:Traslado'][0]['$'];
    this.invoiceData.base = Number(impuestos['Base']);
    this.invoiceData.taxes = Number(impuestos['Importe']);
    this.invoiceData.total = Number(impuestos['Base']) + Number(impuestos['Importe']);
  }
}
